var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('first-page'),_c('second-page'),_c('istoria-page',{attrs:{"id":"istoria"}}),_c('beneficiile-page',{attrs:{"id":"beneficiile"}}),_c('scopul-page',{attrs:{"id":"scopul"}}),_c('contacts-page',{attrs:{"id":"contacts"}}),_c('footer-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }